export enum NotesModes {
    ONLY_SALES_NOTES = 0,
    ALL_NOTES = 1
}



// WEBPACK FOOTER //
// ./src/app/modules/notes/notes.modes.ts